import Explain from '../views/Explain'
import Login from '../views/Login'
import PaperList from '../views/PaperList'
import Router from 'vue-router'
import Vue from 'vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'PaperList',
      component: PaperList
    },
    {
      path: '/Explain/:homeworkId?/:classId?/:token/:wrongScan?',
      name: 'Explain',
      component: Explain
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js